import { gql } from "@apollo/client";

/**
 * Crisp Identity Verification signature for the logged-in user.
 *
 * Returns `{ email, signature }` (the HMAC of the email produced server-side),
 * or `null` if identity verification is not configured on the API. The web app
 * uses this to push a *verified* email to the Crisp chatbox after login so that
 * the operator widget (and Hugo's `get_user` tool) can trust the session email.
 */
export const CRISP_IDENTITY = gql`
  query CrispIdentity {
    crispIdentity {
      email
      signature
    }
  }
`;
